var exports = {
  "O0": "xcc377c0b--8d02c9--rating",
  "p_": "xcc377c0b--8d02c9--list",
  "AS": "xcc377c0b--8d02c9--item",
};

module.exports = exports;
